import { render } from "./ViewCallLogs.vue?vue&type=template&id=0b0d791e&scoped=true"
import script from "./ViewCallLogs.vue?vue&type=script&lang=js"
export * from "./ViewCallLogs.vue?vue&type=script&lang=js"

import "./ViewCallLogs.vue?vue&type=style&index=0&id=0b0d791e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\fchristo.ETAGEN\\Documents\\Adam-Backend\\adam-aibackend\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b0d791e"]])

export default __exports__